import {
  BRAND_DETAILS_PAGE,
  BRAND_COMPATIBILITY_COMPATIBLE,
  BRAND_COMPATIBILITY_QUERY_NAME,
  BRAND_SORT_OPTION_QUERY_NAME,
  BRAND_SORT_BY_PRICE_LOW_TO_HIGH
} from 'constant'
import { kebabCase } from 'lodash'

export const processBrandPageLink = (link, hasActiveVehicle) =>
  !hasActiveVehicle ?
    `${link}?${BRAND_SORT_OPTION_QUERY_NAME}=${BRAND_SORT_BY_PRICE_LOW_TO_HIGH}` :
    `${link}?${BRAND_COMPATIBILITY_QUERY_NAME}=${BRAND_COMPATIBILITY_COMPATIBLE}&${BRAND_SORT_OPTION_QUERY_NAME}=${BRAND_SORT_BY_PRICE_LOW_TO_HIGH}`

export const createBrandPageLink = ({ brandName = '', brandId = '', hasActiveVehicle }) => {
  const brand = kebabCase(brandName)
  const link = `${BRAND_DETAILS_PAGE}${brand}/${brandId}`

  return processBrandPageLink(link, hasActiveVehicle)
}
